import { Switch, type SwitchProps } from '../../components/switch';
import { BodyDefault } from '../../components/typography';

export const TableSwitch = ({ children, ...restProps }: SwitchProps) => {
  return (
    <Switch {...restProps}>
      <BodyDefault as="span" color="fg.neutral.default">
        {children}
      </BodyDefault>
    </Switch>
  );
};
